(() => {
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('gx10-ready');

  const prepareMotion = (scope = document) => {
    const revealTargets = scope.querySelectorAll(
      'main .shopify-section, #product-grid > .grid__item, .related-products .grid__item, .footer .footer-block, .jdgm-rev'
    );
    revealTargets.forEach((node, index) => {
      if (node.dataset.gx10Motion === 'true') return;
      node.dataset.gx10Motion = 'true';
      node.classList.add('gx10-reveal');
      node.style.setProperty('--gx10-delay', `${Math.min(index % 5, 4) * 65}ms`);
    });

    scope.querySelectorAll('.card-wrapper, .collection-list__item, .multicolumn-card, .jdgm-rev').forEach((node) => {
      node.classList.add('gx10-lift');
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach((node) => node.classList.add('gx10-in'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gx10-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.06 });
    revealTargets.forEach((node) => observer.observe(node));
  };

  const announceStudio = () => {
    const chip = document.querySelector('[data-gxc-media-open]');
    if (!chip) return;
    chip.addEventListener('click', () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'mark10_media_customize_click' });
    });
  };

  const boot = (scope = document) => {
    prepareMotion(scope);
    announceStudio();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
